import { render, staticRenderFns } from "./KabJayapura.vue?vue&type=template&id=7a75e3b6"
import script from "./KabJayapura.vue?vue&type=script&lang=js"
export * from "./KabJayapura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports